// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","Storefront":"HBiJOe","AltTheme":"_1G2SYY","fadeInFrames":"_2H4NgY"};